import { z } from "zod";
import { ReactionType, ReactionsList } from "../reaction.js";

export const RSSFeedSource = z.object({
    id: z.number(),
    url: z.string(),
    title: z.string(),
    category: z.string().nullable(),
});

export const RSSFeedItem = z.object({
    id: z.number(),
    title: z.string(),
    url: z.string(),
    authorName: z.string().nullable(),
    imageUrl: z.string().nullable(),
    excerpt: z.string().nullable(),
    publishedAt: z.string(),
    feedSourceTitle: z.string().nullable(),
});

export const schema = {
    listSources: {
        output: z.object({
            feeds: z.array(RSSFeedSource),
        }),
    },
    getReactions: {
        input: z.object({
            feedId: z.number(),
        }),
        output: z.object({
            reaction: ReactionsList,
        }),
    },
    feedReaction: {
        input: z.object({
            feedId: z.number(),
            reactionType: ReactionType,
        }),
        output: z.void(),
    },
    latestEntries: {
        input: z.object({
            searchTerm: z.string().nullable(),
        }),
        output: z.object({
            entries: z.array(RSSFeedItem),
        }),
    },
    entriesByFeed: {
        input: z.object({
            feedId: z.number(),
            searchTerm: z.string().nullable(),
        }),
        output: z.object({
            entries: z.array(RSSFeedItem),
        }),
    },

    groupedEntries: {
        input: z.object({
            category: z.string().nullable(),
        }),
        output: z.record(z.string(), z.array(RSSFeedItem)),
    },
    getFullArticle: {
        input: z.object({
            articleId: z.number(),
        }),
        output: z.object({
            success: z.boolean(),
            content: z.string().optional(),
            error: z.string().optional(),
        }),
    },
    similarArticles: {
        input: z.object({
            articleId: z.number(),
            limit: z.number().min(1).max(20).default(10),
        }),
        output: z.object({
            entries: z.array(RSSFeedItem),
        }),
    },
};
